import { Slider } from "@mui/material";
import { setInvestmentPlan, setPortfolioValue } from "src/store/features/onboarding.slice";
import { useAppDispatch } from "src/store/store";
import { useFormikContext } from "formik";
import { FormValues } from "./utils/formSchema";

interface StyledInvestmentSliderProps {
  type: "investment" | "portfolio";
}

export default function StyledInvestmentSlider({ type }: StyledInvestmentSliderProps) {
  const marks = [
    {
      value: 0,
      label: type === "investment" ? "$500" : "$0",
    },
    {
      value: 20,
      label: "$10k",
    },
    {
      value: 40,
      label: "$50k",
    },
    {
      value: 60,
      label: "$100k",
    },
    {
      value: 80,
      label: "$500k",
    },
    {
      value: 95,
      label: "$1m",
    },
  ];

  function valuetext(value: number) {
    return `${value}`;
  }

  const valueToLabel = (value: number, type: "investment" | "portfolio") => {
    if (value > 95) return "$1M+";
    if (value > 80) return "$500K-$1M";
    if (value > 60) return "$100K-$500K";
    if (value > 40) return "$50K-$100K";
    if (value > 20) return "$10K-$50K";
    return type === "investment" ? "$500-$10K" : "$0-$10K";
  };

  const dispatch = useAppDispatch();
  const { setFieldValue } = useFormikContext<FormValues>();

  return (
    <Slider
      aria-label="Small steps"
      marks={marks}
      getAriaValueText={valuetext}
      valueLabelDisplay="auto"
      sx={{
        color: "#0BEC9F",
        "& .MuiSlider-thumb": {
          bgcolor: "white",
          border: "5px solid black",
        },
        "& .MuiSlider-valueLabel": {
          borderRadius: "8px",
          opacity: 0.9,
          backgroundColor: "#F0FEF9",
          color: "#002035",
          fontSize: "14px",
        },
      }}
      valueLabelFormat={(value) => valueToLabel(value, type)}
      onChangeCommitted={(event, value) => {
        const unformatedValue = valueToLabel(value as number, type);
        if (type === "investment") {
          dispatch(setInvestmentPlan(unformatedValue));
          setFieldValue("investmentPlan", unformatedValue);
        } else {
          dispatch(setPortfolioValue(unformatedValue));
          setFieldValue("portfolioValue", unformatedValue);
        }
      }}
    />
  );
}
